import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PaymentdetailsService } from '../search-booking/paymentdetailstab.service';
import { AdbookingService } from '../services/adbooking.service';

@Component({
  selector: 'app-orderdetails',
  templateUrl: './orderdetails.component.html',
  styleUrls: ['./orderdetails.component.css']
})
export class OrderdetailsComponent implements OnInit {
  orderid: any;
  bookingdetail: any;
  email: any;
  adtype: any;
  adpage: any;
  adsize: any;
  adcategory: any;
  noofdays: any;
  addate: any;
 
  adcost: any;
  imagename: any;
  totalCost: any;
  freedays: any;
  frees: any;
  free: any;
  status: any;
  adContent: any;
  token: any;
  customerdetail: any;
  username: any;
  mobilenumber: any;
  location: any;
  paymentdetails: any;
  payment_method: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private paymentdetailsService:PaymentdetailsService,
    private adbookingservice: AdbookingService

) {
 this.route.params.subscribe(

  params => {
    console.log(params);
  this.orderid = params.orderid;
    console.log(this.orderid);



this.paymentdetailsService.getadcustdetails(this.orderid).subscribe(
  resp => {
    this.bookingdetail = resp.bookingdetails;
    this.email = this.bookingdetail.email;
    this.adtype = this.bookingdetail.adtype;
    this.adpage = this.bookingdetail.adpage;
    this.adsize = this.bookingdetail.adsize;
    this.orderid = this.bookingdetail.orderid;
    this.adcategory = this.bookingdetail.adcategory;
     this.noofdays = this.bookingdetail.noofdays;
     this.addate = this.bookingdetail.addate;
     this.location = this.bookingdetail.location;
     this.adcost = (this.bookingdetail.adcost).toFixed(2);
     this.totalCost = (this.bookingdetail.totalCost).toFixed(2);
     this.imagename = this.bookingdetail.imagename;
     this.adContent = this.bookingdetail.adContent;
     this.status = this.bookingdetail.status;
     this.free = this.bookingdetail.free;
     this.frees = this.bookingdetail.frees;
     this.freedays = this.bookingdetail.freedays;
     console.log(this.email)
     console.log(this.freedays)
     
     this.paymentdetails = resp.paymentdetails;
     this.payment_method = this.paymentdetails.payment_method;
  

     this.customerdetail =resp.customerdetails;
     this.username = this.customerdetail.username;
     this.mobilenumber = this.customerdetail.mobilenumber;
 });

},
error => console.log(error)
);


}

  ngOnInit() {


  
}
download(imagename) {
  console.log(this.email)
  this.adbookingservice.getFile(this.email,this.orderid,this.imagename).subscribe(
    resp => {
      console.log(resp);
      const downloadURL = window.URL.createObjectURL(resp);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = imagename;
      link.click();
      link.remove();
    });
}
}